import { PostponeStepSchema } from '@feedyou/schema'

import { search } from './services/search'
import { unsetDialogs } from './services/unsetDialogs'
import { getUsedDialogs } from './services/getUsedDialogs'
import { createStepService } from '../../utils/stepServices/createStepServices'
import { getSubdialogConnectionsMetadata } from './services/getSubdialogConnectionsMetadata'

export const postponeStepService = createStepService<PostponeStepSchema, {}>({
  search,

  unsetDialogs,
  getUsedDialogs,
  getSubdialogConnectionsMetadata
})
